import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/success-view.svg'


const _hoisted_1 = { class: "success-view container" }
const _hoisted_2 = {
  class: "col-12 mt-4",
  style: {"height":"20rem"}
}
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "button-to-homepage mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_contact = _resolveComponent("contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumbs),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title-success-view col-12" }, [
      _createElementVNode("h1", null, "Parabéns! Sua solicitação foi enviada com sucesso!")
    ], -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "description-sucess-view col-12" }, [
      _createElementVNode("p", null, "Você receberá um e-mail com a aprovação de seu Certificado e com as instruções para a Instalação!")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: _normalizeClass(["fly", [_ctx.classFly ? "fly-finish" : ""]]),
        alt: "Solicitação enviada com sucesso",
        src: _imports_0
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary",
          to: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              class: "me-2",
              name: "house",
              style: {"font-size":"1.2rem"}
            }),
            _cache[0] || (_cache[0] = _createElementVNode("span", null, "Voltar para home", -1))
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_contact)
  ]))
}